import React from "react";
import {PLACEHOLDER_MSG_TO} from "./inputTypes";
import styled from "styled-components";

const TextareaMessageTo = ({
                               selectedOption,
                               handleChange,
                               name,
                               placeholder
                           }) => {
    return (
        <Fieldset>
            <label>
                <textarea
                    id={"msg-to"}
                    placeholder={placeholder === "" ? PLACEHOLDER_MSG_TO : placeholder}
                    name={name}
                    value={selectedOption.message}
                    onChange={handleChange}
                />
            </label>
        </Fieldset>
    )
}

const Fieldset = styled.fieldset`
    border: none;
`

export default TextareaMessageTo;